import { ATTRIBUTION_PARAMS } from "@shared/constants";

/**
 * Checks if a URL contains any attribution-related query parameters
 * @param url - The URL to check (string or URL object)
 * @returns true if any attribution params are found, false otherwise
 */
export default function hasAttributionParams(url: string | URL): boolean {
	try {
		const urlObj = typeof url === "string" ? new URL(url) : url;
		const params = urlObj.searchParams;

		for (const key of params.keys()) {
			if (ATTRIBUTION_PARAMS.has(key.toLowerCase())) {
				return true;
			}
		}

		return false;
	} catch {
		// Invalid URL, return false
		return false;
	}
}
